import { useEffect, useRef } from 'react';
import * as Models from 'models';
import { ResetHeightFunction } from './useCell';

type Props = {
  padding: Models.BoxPropertyMap | undefined;
  border: Models.BorderWidthMap | undefined;
  resetHeight: ResetHeightFunction;
};

export function usePaddingBorderEffect({
  padding,
  border,
  resetHeight }: Props,
): void {

  const resetHeightRef = useRef(resetHeight);
  useEffect(() => {
    resetHeightRef.current = resetHeight;
  }, [resetHeight]);

  const prevPadding = useRef(padding);
  const prevBorder = useRef(border);

  useEffect(() => {
    if (!prevPadding.current || !prevBorder.current) {
      return;
    }

    const isPaddingSame = prevPadding.current === padding;
    const isBorderSame = prevBorder.current === border;

    if (isBorderSame && isPaddingSame) {
      return;
    }

    prevPadding.current = padding;
    prevBorder.current = border;
    // Wait for DOM to update with new padding before recalculating height
    requestAnimationFrame(() => {
      const updateFromPaddingBorderEffect = true;
      resetHeightRef.current?.(updateFromPaddingBorderEffect);
    });
  }, [padding, border]);
}
